<template>
   <div style="text-align: center; margin:auto; max-width:900px">
        <img
        src="public/images/site/crear.svg"
        id="challenges"
        alt="Miles de proyectos"
        style="width:80%; margin-top: 100px"
      />
        <div 
        style="
        background-color: #ececec;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-left: 20px;
        margin-right: 20px;
        border-radius:15px;
        "
        >
        <div class="container my-4">    

<carousel :autoplay="true" :perPageCustom="[[768, 2], [1024, 3]]" :paginationEnabled="false">
  <slide>
    <img class="card-img-top" src="public/images/site/desafio1.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio2.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio3.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio4.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio5.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio6.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio7.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio8.jpg" alt="Card image cap">  
  </slide>
  <slide>
    <img class="card-img-top" src="public/images/site/desafio9.jpg" alt="Card image cap">  
  </slide>
</carousel>





  </div>
        
        
        
        </div>
        <img
        src="public/images/site/paint-grey.svg"
        id="challenges"
        alt="Miles de proyectos"
        style=" margin-top:-5px
        "
      />



   




      
      </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel';

  export default {
    
    name: 'app',

    data () {
      return {
        errorMessage:"",
        login:{
          usuario:"",
          password:""
          }
      }
    },

    computed:{
    ...mapGetters(['pathAPI','userLogged']),

    },

    methods:{
     
    },

    computed:{

    }
        ,
    components:{
      Carousel,
      Slide
    },

    mounted: function(){

    },


  }
</script>

<style>
.card-img-top{
  border-radius: 15px;
  padding: 10px
}

</style>


// WEBPACK FOOTER //
// src/components/startPage/ChallengeBanner.vue